const map = {
  tr: {
    lang: "turkce",

    // common
    "/common/error": "Hata",
    "/common/UnknownError": "Bilinmeyen Hata",
    "/common/Loading": "Yükleniyor",

    // institutions
    "/institution/iyte": "IYTE",
    "/institution/ege": "EGE",
    "/institution/ktun": "KTUN",
    "/institution/etu": "TOBB ETU",
    "/institution/pau": "PAU",
    "/institution/ieu": "IEU",
    "/institution/mef": "MEF",

    //awards
    "/awards/awards/researcher": "Araştırmacı",
    "/awards/awards/title": "Başlık",
    "/awards/awards/date": "Tarih",

    //equipments
    "/equipments/equipments/title": "Başlık",

    // dergiDagilimi
    "/home/dergiDagilimi/title": "Dergi Dağılımı",

    // enCokAtif
    "/home/enCokAtif/title": "Atıf Sayısı",

    // makaleSayisi
    "/home/makaleSayisi/title": "Makale Sayısı",

    // qDagilimi
    "/home/qDagilimi/title": "Q Dağılımı",

    // dashboard
    "/ou/dashboard/scholarlyOutput": "Bilimsel Çıktı",
    "/ou/dashboard/journalArticles": "Dergi Makaleleri",
    "/ou/dashboard/citations": "Atıflar",
    "/ou/dashboard/patents": "Patentler",
    "/ou/dashboard/hIndex": "H-İndeks",
    "/ou/dashboard/h5Index": "H5-İndeks",
    "/ou/dashboard/i10Index": "I10-İndeks",
    "/ou/dashboard/citationsPerPublication": "Yayın başına Atıf",
    "/ou/dashboard/distinctJournals": "Bağımsız Dergiler",
    "/ou/dashboard/distinctJournalCategories": "Bağımsız Dergi Kategorileri",
    "/ou/dashboard/averagePrestigePerPublication":
      "Yayın Başına Ortalama Prestij",
    "/ou/dashboard/supervisedMscTheses": "Yüksek Lisans Tez Danışmanı",
    "/ou/dashboard/supervisedPhdTheses": "Doktora Tez Danışmanı",
    "/ou/dashboard/projects": "Projeler",
    "/ou/dashboard/totalFunding": "Toplam Fon",
    "/ou/dashboard/courses": "Dersler",
    "/ou/dashboard/lecturingScore": "Ders Verme Puanı",
    "/ou/dashboard/viewsDownloads": "Görüntülenme / İndirme",
    "/ou/dashboard/openAccess": "Açık Erişim Kaynak",
    "/ou/dashboard/CitationIndexMetrics": "Atıf ve indeksle ilişkili metrikler",
    "/ou/dashboard/Scopus": "Scopus",
    "/ou/dashboard/CalculatedFromTheData": "verilerinden hesaplanmaktadır.",

    // journals
    "/ou/journals/journal": "Dergi",
    "/ou/journals/hIndex": "H-İndeks",
    "/ou/journals/quartile": "Çeyrek",
    "/ou/journals/country": "Bölge",
    "/ou/journals/publisher": "Yayınlayan",
    "/ou/journals/count": "Sayı",

    // pubCountByYears
    "/ou/pubCountByYears/title": "Bilimsel Çıktı",

    // pubStudyAreaDist
    "/ou/pubStudyAreaDist/title": "",

    // pubStudyCategoryDist
    "/ou/pubStudyCategoryDist/title": "",

    // sdgWall
    "/ou/rosettes/no-sdg-rosettes":
      "Bu organizasyonun Sürdürülebilir Kalkınma Hedefleri için bir rozeti bulunmamaktadır.",

    // doktoraTeziSayisi
    "/reports/doktoraTeziSayisi/title": "Bölümler",

    // masterTeziSayisi
    "/reports/masterTeziSayisi/title": "Bölümler",

    // scimagoTurkey
    "/reports/scimagoTurkey/title": "Scimago Enstitüler Sıralaması - Türkiye",
    "/reports/scimagoTurkey/compare": "Üniversiteleri Karşılaştır",
    "/reports/scimagoTurkey/search": "Ara",

    // scimagoWorldwide
    "/reports/scimagoWorldwide/title":
      "Scimago Enstitüler Sıralaması - Uluslararası",
    "/reports/scimagoWorldwide/compare": "Üniversiteleri Karşılaştır",
    "/reports/scimagoWorldwide/search": "Ara",

    // yayinSayisi
    "/reports/yayinSayisi/title": "Bölümler",

    // raporSayisi
    "/reports/reportsCount": "Rapor Sayısı",

    // dashboardExternalScholar
    "/rs/profile/dashboardExternalScholar/allSince2016": "tümü / 2016'dan beri",
    "/rs/profile/dashboardExternalScholar/citations": "Atıflar",
    "/rs/profile/dashboardExternalScholar/hIndex": "h-indeks",
    "/rs/profile/dashboardExternalScholar/i10Index": "i10-indeks",
    "/rs/profile/dashboardExternalScholar/articles": "Makaleler",
    "/rs/profile/dashboardExternalScholar/coAuthors": "Ortak Yazarlar",
    "/rs/profile/dashboardExternalScholar/citesPerYear": "Yıllık Atıflar",
    "/rs/profile/dashboardExternalScholar/interests": "İlgi Alanları",

    // dashboardExternalSemanticScholar
    "/rs/profile/dashboardExternalSemanticScholar/citations": "Atıflar",
    "/rs/profile/dashboardExternalSemanticScholar/hIndex": "H-İndeks",
    "/rs/profile/dashboardExternalSemanticScholar/documents": "Dokümanlar",
    "/rs/profile/dashboardExternalSemanticScholar/influentialCitationCount":
      "Etkili Atıf Sayısı",

    // dashboardExternalScopus
    "/rs/profile/dashboardExternalScopus/documents": "Dokümanlar",
    "/rs/profile/dashboardExternalScopus/hIndex": "h-indeks",
    "/rs/profile/dashboardExternalScopus/citations": "Atıflar",
    "/rs/profile/dashboardExternalScopus/coAuthors": "Ortak Yazarlar",
    "/rs/profile/dashboardExternalScopus/fieldWeightedCitationImpact":
      "Alan Ağırlıklı Atıf Etkisi",

    // dashboardExternalWos
    "/rs/profile/dashboardExternalWos/institution-affiliated-articles":
      "Kurum Adresli Makaleler",
    "/rs/profile/dashboardExternalWos/institution-affiliated-citations":
      "Kurum Adresli Atıflar",

    // dashboardExternalOpenAlex
    "/rs/profile/dashboardExternalOpenAlex/worksCount": "Çalışma Sayısı",
    "/rs/profile/dashboardExternalOpenAlex/citationCount": "Atıf Sayısı",
    "/rs/profile/dashboardExternalOpenAlex/nationalWorksCount":
      "Ulusal Çalışma Sayısı",
    "/rs/profile/dashboardExternalOpenAlex/internationalWorksCount":
      "Uluslararası Çalışma Sayısı",

    // dashboardSummary
    "/rs/profile/dashboardSummary/info":
      "Aşağıdaki sayılar ve metrikler araştırmacının sadece kurumumuzdaki akademik çıktıları ile sınırlıdır.",
    "/rs/profile/dashboardSummary/scholarlyOutput": "Bilimsel Çıktı",
    "/rs/profile/dashboardSummary/citationCount": "Atıf Sayısı",
    "/rs/profile/dashboardSummary/supervisedTheses": "Tez Danışmanlığı",
    "/rs/profile/dashboardSummary/openAccessCount": "Açık Erişim Sayısı",

    // sdgRosettes

    "/rs/rosettes/sdg-report":
      "Sürdürülebilir Kalkınma Hedefleri Raporu Puanları",
    "/rs/rosettes/sdg-rosettes":
      "Yayının Sürdürülebilir Kalkınma Hedefleri Rozetleri",
    "/rs/rosettes/no-sdg-rosettes":
      "Bu yayının Sürdürülebilir Kalkınma Hedefleri için bir rozeti bulunmamaktadır.",

    "/rosettes/noPoverty": "Yoksulluğa Son",
    "/rosettes/zeroHunger": "Açlığa Son",
    "/rosettes/goodHealthAndWellBeing": "Sağlık ve Kaliteli Yaşam",
    "/rosettes/qualityEducation": "Nitelikli Eğitim",
    "/rosettes/genderEquality": "Toplumsal Cinsiyet Eşitliği",
    "/rosettes/cleanWaterAndSanitation": "Temiz Su ve Sanitasyon",
    "/rosettes/affordableAndCleanEnergy": "Erişilebilir ve Temiz Enerji",
    "/rosettes/decentWorkAndEconomicGrowth":
      "İnsan Yakışır İş ve Ekonomik Büyüme",
    "/rosettes/industryInnovationAndInfrastructure":
      " Sanayi, Yenilikçilik ve Altyapı",
    "/rosettes/reducedInequalities": "Eşitsizliklerin Azaltılması",
    "/rosettes/sustainableCitiesAndCommunities":
      "Sürdürülebilir Şehirler ve Topluluklar",
    "/rosettes/responsibleConsumptionAndProduction":
      "Sorumlu Üretim ve Tüketim",
    "/rosettes/climateAction": "İklim Eylemi",
    "/rosettes/lifeBelowWater": "Sudaki Yaşam",
    "/rosettes/lifeOnLand": "Karasal Yaşam",
    "/rosettes/peaceJusticeAndStrongInstitutions":
      "Barış, Adalet ve Güçlü Kurumlar",
    "/rosettes/partnershipsForTheGoals": "Amaçlar İçin Ortaklıklar",
    "/rosettes/researchProducts": "Araştırma Ürünleri",

    // courses
    "/rs/courses/code": "Kod",
    "/rs/courses/title": "Başlık",
    "/rs/courses/credits": "Kredi",
    "/rs/courses/students": "Öğrenciler",
    "/rs/courses/year": "Yıl",
    "/rs/courses/semester": "Dönem",

    // dashboard
    "/rs/dashboard/scholarlyOutput": "Bilimsel Çıktı",
    "/rs/dashboard/journalArticles": "Dergi Makaleleri",
    "/rs/dashboard/scopus-citations": "Scopus Atıflar",
    "/rs/dashboard/patents": "Patentler",
    "/rs/dashboard/hIndex": "H-İndeks",
    "/rs/dashboard/h5Index": "H5-İndeks",
    "/rs/dashboard/i10Index": "I10-İndeks",
    "/rs/dashboard/citationsPerPublication": "Yayın başına Atıf",
    "/rs/dashboard/distinctJournals": "Bağımsız Dergiler",
    "/rs/dashboard/distinctJournalCategories": "Bağımsız Dergi Kategorileri",
    "/rs/dashboard/averagePrestigePerPublication":
      "Yayın Başına Ortalama Prestij",
    "/rs/dashboard/supervisedMscTheses": "Yüksek Lisans Tez Danışmanlığı",
    "/rs/dashboard/supervisedPhdTheses": "Doktora Tez Danışmanlığı",
    "/rs/dashboard/projects": "Projeler",
    "/rs/dashboard/totalFunding": "Toplam Fon",
    "/rs/dashboard/courses": "Dersler",
    "/rs/dashboard/lecturingScore": "Ders Verme Puanı",
    "/rs/dashboard/viewsDownloads": "Görüntülenme / İndirme",
    "/rs/dashboard/openAccessCount": "Açık Erişim Sayısı",
    "/rs/dashboard/CitationIndexMetrics": "Atıf ve indeksle ilişkili metrikler",
    "/rs/dashboard/Scopus": "Scopus",
    "/rs/dashboard/CalculatedFromTheData": "verilerinden hesaplanmaktadır.",

    // editProfile
    "/rs/editProfile/title": "",

    // journals
    "/rs/journals/journal": "Dergi",
    "/rs/journals/hIndex": "H-İndeks",
    "/rs/journals/quartile": "Çeyrek",
    "/rs/journals/country": "Bölge",
    "/rs/journals/publisher": "Yayınlayan",
    "/rs/journals/count": "Sayı",

    // lecturingScore
    "/rs/lecturingScore/title": "Ders Verme Puanı",

    // profile
    "/rs/profile/publicationTypes/articles": "Makaleler",
    "/rs/profile/publicationTypes/conferences": "Konferanslar",
    "/rs/profile/publicationTypes/books": "Kitaplar Parçaları",
    "/rs/profile/publicationTypes/bookChapters": "Kitap / Kitap Bölümleri",
    "/rs/profile/publicationTypes/others": "Diğerleri",
    "/rs/profile/publications/issueDate": "Tarihi",
    "/rs/profile/publications/title": "Başlık",
    "/rs/profile/publications/author": "Yazar(lar)",
    "/rs/profile/publications/scopus-cited": "Scopus Atıflar",
    "/rs/profile/publications/scopus-quartile": "Scopus Q Dağıl.",
    "/rs/profile/publications/etAll": "ve diğ.",
    "/rs/profile/theses/issueDate": "Tarihi",
    "/rs/profile/theses/title": "Başlık",
    "/rs/profile/theses/type": "Tür",
    "/rs/profile/theses/author": "Yazar(lar)",
    "/rs/profile/courses/code": "Kod",
    "/rs/profile/courses/title": "Başlık",
    "/rs/profile/courses/credits": "Kredi",
    "/rs/profile/courses/students": "Öğrenciler",
    "/rs/profile/courses/year": "Yıl",
    "/rs/profile/courses/semester": "Dönem",
    "/rs/profile/affiliations/role": "Rol",
    "/rs/profile/affiliations/organization": "Birim",
    "/rs/profile/affiliations/startDate": "Başlangıç Tarihi",
    "/rs/profile/affiliations/endDate": "Bitiş Tarihi",
    "/rs/profile/educations/program": "Bölüm",
    "/rs/profile/educations/university": "Üniversite",
    "/rs/profile/educations/startDate": "Başlangıç Tarihi",
    "/rs/profile/educations/endDate": "Bitiş Tarihi",
    "/rs/profile/awards/title": "Başlık",
    "/rs/profile/awards/date": "Tarih",

    "/rs/profile/variants": "Varyantlar",
    "/rs/profile/mainAffiliation": "Ana Birim",
    "/rs/profile/email": "Eposta",
    "/rs/profile/otherEmails": "Diğer Epostalar",
    "/rs/profile/orcid": "ORCID",
    "/rs/profile/scopusAuthorId": "Scopus Author ID",
    "/rs/profile/wosResearcherId": "WoS Researcher ID",
    "/rs/profile/googleScholar": "Google Scholar",
    "/rs/profile/yokLink": "YÖK Akademik",
    "/rs/profile/documents": "Dokümanlar",
    "/rs/profile/website": "Website",
    "/rs/profile/status": "Durum",
    "/rs/profile/status/current": "Aktif Personel",
    "/rs/profile/status/former": "Eski Personel",
    "/rs/profile/status/external": "Kurum Dışı Personel",
    "/rs/profile/bibliometrics": "Bibliyometri",
    "/rs/profile/tab-title/affiliated": " Kurumuna Bağlı",
    "/rs/profile/tab-title/about-researcher": "Araştırmacı Hk.",
    "/rs/profile/tab/publications": "Kurum Adresli Yayınlar",
    "/rs/profile/tab/theses": "Tez Danışmanlığı",
    "/rs/profile/tab/projects": "Projeler",
    "/rs/profile/tab/courses": "Dersler",
    "/rs/profile/tab/affiliations": "Çalıştığı Kurumlar",
    "/rs/profile/tab/educations": "Eğitimler",
    "/rs/profile/tab/biography": "Biyografi",
    "/rs/profile/tab/biographyNative": "Yerli Biyografi",
    "/rs/profile/tab/competencyCloud": "Yetkinlik Bulutu",
    "/rs/profile/tab/researchInterests": "Araştırma İlgi Alanları",
    "/rs/profile/tab/awards": "Ödüller",
    "/rs/profile/projects/id": "ID",
    "/rs/profile/projects/program": "Program",
    "/rs/profile/projects/grantNo": "Hibe No",
    "/rs/profile/projects/duration": "Süre",
    "/rs/profile/projects/startDate": "Başlangıç Tarihi",
    "/rs/profile/projects/endDate": "Bitiş Tarihi",
    "/rs/profile/projects/fund": "Fon",
    "/rs/profile/print-footer": "GCRIS tarafından oluşturulmuştur.",
    "/rs/profile/google-analytics/visitor-traffic":
      "Google Analytics Ziyaretçi Trafiği",
    "/rs/profile/google-analytics/visitor-traffic-is-loading":
      "Google Analytics Ziyaretçi Trafiği Yükleniyor...",
    "/rs/profile/valid-for-all-publications": " içindeki tüm yayınlar.",
    "/rs/profile/all-publications-orcid": "Tüm yayınlar (ORCID)",

    // pubCountByYears
    "/rs/pubCountByYears/title": "Bilimsel Çıktı",

    // pubStudyAreaDist
    "/rs/pubStudyAreaDist/title": "Başlık",

    // pubStudyCategoryDist
    "/rs/pubStudyCategoryDist/title": "Başlık",

    // charts/handle/sobiad
    "/charts/handle/sobiad/publicationCount": "Yayın Sayısı",

    // charts/handle/semantic-scholar
    "/charts/handle/semantic-scholar/citationCount": "Alıntılama Sayısı",

    // charts/handle/open-citations
    "/charts/handle/open-citations/citationCount": "Alıntılama Sayısı",

    // charts/handle/semantic-scholar-recommendations
    "/charts/handle/semantic-scholar/recommendation/year": "Yıl",
    "/charts/handle/semantic-scholar/recommendation/by": "Yazarlar",
    "/charts/handle/semantic-scholar/recommendation/citationCount":
      "Atıf Sayısı",
    "/charts/handle/semantic-scholar/recommendation/semanticScholarRecommendations":
      "Semantic Scholar Tavsiyeleri",

    // charts/handle/world-map
    "/charts/handle/world-map": "Veri analiz tarih aralığı",
    "/charts/handle/world-map-current": "Anlık (Üç dakikada bir yenilenir)",
    "/charts/handle/world-map/total-view": "Toplam Görüntülenme Sayısı",
  },
  en: {
    lang: "english",

    // common
    "/common/error": "Error",
    "/common/UnknownError": "Unknown Error",
    "/common/Loading": "Loading",

    // institutions
    "/institution/iyte": "IZTECH",
    "/institution/ege": "EGE",
    "/institution/ktun": "KTUN",
    "/institution/etu": "TOBB ETU",
    "/institution/pau": "PAU",
    "/institution/ieu": "IUE",
    "/institution/mef": "MEF",

    //awards
    "/awards/awards/researcher": "Researcher",
    "/awards/awards/title": "Title",
    "/awards/awards/date": "Date",

    //equipments
    "/equipments/equipments/title": "Title",

    // dergiDagilimi
    "/home/dergiDagilimi/title": "Journal Distribution",

    // enCokAtif
    "/home/enCokAtif/title": "Citation Counts",

    // makaleSayisi
    "/home/makaleSayisi/title": "Journal Articles",

    // qDagilimi
    "/home/qDagilimi/title": "Q Distribution",

    // dashboard
    "/ou/dashboard/scholarlyOutput": "Scholarly Output",
    "/ou/dashboard/journalArticles": "Journal Articles",
    "/ou/dashboard/citations": "Citations",
    "/ou/dashboard/patents": "Patents",
    "/ou/dashboard/hIndex": "H-Index",
    "/ou/dashboard/h5Index": "H5-Index",
    "/ou/dashboard/i10Index": "I10-Index",
    "/ou/dashboard/citationsPerPublication": "Citations per Publication",
    "/ou/dashboard/distinctJournals": "Distinct Journals",
    "/ou/dashboard/distinctJournalCategories": "Distinct Journal Categories",
    "/ou/dashboard/averagePrestigePerPublication":
      "Average Prestige Per Publication",
    "/ou/dashboard/supervisedMscTheses": "Supervised MScTheses",
    "/ou/dashboard/supervisedPhdTheses": "Supervised PhDTheses",
    "/ou/dashboard/projects": "Projects",
    "/ou/dashboard/totalFunding": "Total Funding",
    "/ou/dashboard/courses": "Courses",
    "/ou/dashboard/lecturingScore": "Lecturing Score",
    "/ou/dashboard/viewsDownloads": "Views / Downloads",
    "/ou/dashboard/openAccess": "Open Access Source",
    "/ou/dashboard/CitationIndexMetrics": "Citation and index related metrics",
    "/ou/dashboard/Scopus": "Scopus",
    "/ou/dashboard/CalculatedFromTheData": "data were used to calculate.",

    // journals
    "/ou/journals/journal": "Journal",
    "/ou/journals/hIndex": "H-index",
    "/ou/journals/quartile": "Quartile",
    "/ou/journals/country": "Country",
    "/ou/journals/publisher": "Publisher",
    "/ou/journals/count": "Count",

    // pubCountByYears
    "/ou/pubCountByYears/title": "Scholarly Output",

    // pubStudyAreaDist
    "/ou/pubStudyAreaDist/title": "",

    // pubStudyCategoryDist
    "/ou/pubStudyCategoryDist/title": "",

    // sdgWall
    "/ou/rosettes/no-sdg-rosettes":
      "This organization does not have a rosette for the Sustainable Development Goals.",

    // doktoraTeziSayisi
    "/reports/doktoraTeziSayisi/title": "Bölümler",

    // masterTeziSayisi
    "/reports/masterTeziSayisi/title": "Bölümler",

    // scimagoTurkey
    "/reports/scimagoTurkey/title": "Scimago Institutions Ranking - Turkey",
    "/reports/scimagoTurkey/compare": "Compare Universities",
    "/reports/scimagoTurkey/search": "Search",

    // scimagoWorldwide
    "/reports/scimagoWorldwide/title":
      "Scimago Institutions Ranking - Worldwide",
    "/reports/scimagoWorldwide/compare": "Compare Universities",
    "/reports/scimagoWorldwide/search": "Search",

    // yayinSayisi
    "/reports/yayinSayisi/title": "Bölümler",

    // raporSayisi
    "/reports/reportsCount": "Reports Count",

    // dashboardExternalScholar
    "/rs/profile/dashboardExternalScholar/allSince2016": "All / Since 2016",
    "/rs/profile/dashboardExternalScholar/citations": "Citations",
    "/rs/profile/dashboardExternalScholar/hIndex": "h-index",
    "/rs/profile/dashboardExternalScholar/i10Index": "i10-index",
    "/rs/profile/dashboardExternalScholar/articles": "Articles",
    "/rs/profile/dashboardExternalScholar/coAuthors": "Co-authors",
    "/rs/profile/dashboardExternalScholar/citesPerYear": "Citation Per Year",
    "/rs/profile/dashboardExternalScholar/interests": "Interests",

    // dashboardExternalSemanticScholar
    "/rs/profile/dashboardExternalSemanticScholar/citations": "Citations",
    "/rs/profile/dashboardExternalSemanticScholar/hIndex": "H-Index",
    "/rs/profile/dashboardExternalSemanticScholar/documents": "Documents",
    "/rs/profile/dashboardExternalSemanticScholar/influentialCitationCount":
      "Influential Citation Count",

    // dashboardExternalScopus
    "/rs/profile/dashboardExternalScopus/documents": "Documents",
    "/rs/profile/dashboardExternalScopus/hIndex": "h-index",
    "/rs/profile/dashboardExternalScopus/citations": "Citations",
    "/rs/profile/dashboardExternalScopus/coAuthors": "Co-authors",
    "/rs/profile/dashboardExternalScopus/fieldWeightedCitationImpact":
      "Field Weighted Citation Impact",

    // dashboardExternalWos
    "/rs/profile/dashboardExternalWos/institution-affiliated-articles":
      "Institution Affiliated Articles",
    "/rs/profile/dashboardExternalWos/institution-affiliated-citations":
      "Institution Affiliated Citations",

    // dashboardExternalOpenAlex
    "/rs/profile/dashboardExternalOpenAlex/worksCount": "Works Count",
    "/rs/profile/dashboardExternalOpenAlex/citationCount": "Citation Count",
    "/rs/profile/dashboardExternalOpenAlex/nationalWorksCount":
      "National Works Count",
    "/rs/profile/dashboardExternalOpenAlex/internationalWorksCount":
      "International Works Count",

    // dashboardSummary
    "/rs/profile/dashboardSummary/info":
      "The numbers and metrics below are limited only to the scholarly outputs generated in this institute.",
    "/rs/profile/dashboardSummary/scholarlyOutput": "Scholarly Output",
    "/rs/profile/dashboardSummary/citationCount": "Citation Count",
    "/rs/profile/dashboardSummary/supervisedTheses": "Supervised Theses",
    "/rs/profile/dashboardSummary/openAccessCount": "Open Access Count",

    // sdgRosettes

    "/rs/rosettes/sdg-report": "Sustainable Development Goals Report Points",
    "/rs/rosettes/sdg-rosettes":
      "Publication's Sustainable Development Goals Rosettes",
    "/rs/rosettes/no-sdg-rosettes":
      "Publication does not have any SDG rosettes",

    "/rosettes/noPoverty": "No Poverty",
    "/rosettes/zeroHunger": "Zero Hunger",
    "/rosettes/goodHealthAndWellBeing": "Good Health and Well-being",
    "/rosettes/qualityEducation": "Quality Education",
    "/rosettes/genderEquality": "Gender Equality",
    "/rosettes/cleanWaterAndSanitation": "Clean Water and Sanitation",
    "/rosettes/affordableAndCleanEnergy": "Affordable and Clean Energy",
    "/rosettes/decentWorkAndEconomicGrowth": "Decent Work and Economic Growth",
    "/rosettes/industryInnovationAndInfrastructure":
      "Industry, Innovation and Infrastructure",
    "/rosettes/reducedInequalities": "Reduced Inequality",
    "/rosettes/sustainableCitiesAndCommunities":
      "Sustainable Cities and Communities",
    "/rosettes/responsibleConsumptionAndProduction":
      "Responsible Consumption and Production",
    "/rosettes/climateAction": " Climate Action",
    "/rosettes/lifeBelowWater": "Life Below Water",
    "/rosettes/lifeOnLand": "Life on Land",
    "/rosettes/peaceJusticeAndStrongInstitutions":
      "Peace and Justice Strong Institutions",
    "/rosettes/partnershipsForTheGoals": "Partnerships to achieve the Goal",
    "/rosettes/researchProducts": "Research Products",

    // courses
    "/rs/courses/code": "Code",
    "/rs/courses/title": "Title",
    "/rs/courses/credits": "Credits",
    "/rs/courses/students": "Students",
    "/rs/courses/year": "Year",
    "/rs/courses/semester": "Semester",

    // dashboard
    "/rs/dashboard/scholarlyOutput": "Scholarly Output",
    "/rs/dashboard/journalArticles": "Journal Articles",
    "/rs/dashboard/scopus-citations": "Scopus Citations",
    "/rs/dashboard/patents": "Patents",
    "/rs/dashboard/hIndex": "H-Index",
    "/rs/dashboard/h5Index": "H5-Index",
    "/rs/dashboard/i10Index": "I10-Index",
    "/rs/dashboard/citationsPerPublication": "Citations per Publication",
    "/rs/dashboard/distinctJournals": "Distinct Journals",
    "/rs/dashboard/distinctJournalCategories": "Distinct Journal Categories",
    "/rs/dashboard/averagePrestigePerPublication":
      "Average Prestige Per Publication",
    "/rs/dashboard/supervisedMscTheses": "Supervised MScTheses",
    "/rs/dashboard/supervisedPhdTheses": "Supervised PhDTheses",
    "/rs/dashboard/projects": "Projects",
    "/rs/dashboard/totalFunding": "Total Funding",
    "/rs/dashboard/courses": "Courses",
    "/rs/dashboard/lecturingScore": "Lecturing Score",
    "/rs/dashboard/viewsDownloads": "View / Download",
    "/rs/dashboard/openAccessCount": "Open Access Count",
    "/rs/dashboard/CitationIndexMetrics": "Citation and index related metrics",
    "/rs/dashboard/Scopus": "Scopus",
    "/rs/dashboard/CalculatedFromTheData": "data were used to calculate.",

    // editProfile
    "/rs/editProfile/title": "",

    // journals
    "/rs/journals/journal": "Journal",
    "/rs/journals/hIndex": "hIndex",
    "/rs/journals/quartile": "Quartile",
    "/rs/journals/country": "Country",
    "/rs/journals/publisher": "Publisher",
    "/rs/journals/count": "Count",

    // lecturingScore
    "/rs/lecturingScore/title": "Lecturing Score",

    // profile
    "/rs/profile/publicationTypes/articles": "Articles",
    "/rs/profile/publicationTypes/conferences": "Conferences",
    "/rs/profile/publicationTypes/books": "Book Parts",
    "/rs/profile/publicationTypes/bookChapters": "Book / Book Chapters",
    "/rs/profile/publicationTypes/others": "Others",
    "/rs/profile/publications/issueDate": "Issue Date",
    "/rs/profile/publications/title": "Title",
    "/rs/profile/publications/author": "Author(s)",
    "/rs/profile/publications/scopus-cited": "Scopus Cited",
    "/rs/profile/publications/scopus-quartile": "Scopus Q Dist.",
    "/rs/profile/publications/etAll": "et. all.",
    "/rs/profile/theses/issueDate": "Issue Date",
    "/rs/profile/theses/title": "Title",
    "/rs/profile/theses/type": "Type",
    "/rs/profile/theses/author": "Author(s)",
    "/rs/profile/courses/code": "Code",
    "/rs/profile/courses/title": "Title",
    "/rs/profile/courses/credits": "Credits",
    "/rs/profile/courses/students": "Students",
    "/rs/profile/courses/year": "Year",
    "/rs/profile/courses/semester": "Semester",
    "/rs/profile/affiliations/role": "Role",
    "/rs/profile/affiliations/organization": "Organization",
    "/rs/profile/affiliations/startDate": "Start Date",
    "/rs/profile/affiliations/endDate": "End Date",
    "/rs/profile/educations/program": "Program",
    "/rs/profile/educations/university": "University",
    "/rs/profile/educations/startDate": "Start Date",
    "/rs/profile/educations/endDate": "End Date",
    "/rs/profile/awards/title": "Title",
    "/rs/profile/awards/date": "Date",

    "/rs/profile/variants": "Variants",
    "/rs/profile/mainAffiliation": "Main Affiliation",
    "/rs/profile/email": "Email",
    "/rs/profile/otherEmails": "Other Emails",
    "/rs/profile/orcid": "ORCID",
    "/rs/profile/scopusAuthorId": "Scopus Author ID",
    "/rs/profile/wosResearcherId": "WoS Researcher ID",
    "/rs/profile/googleScholar": "Google Scholar",
    "/rs/profile/yokLink": "YÖK Academic",
    "/rs/profile/documents": "Documents",
    "/rs/profile/website": "Website",
    "/rs/profile/status": "Status",
    "/rs/profile/status/current": "Current Staff",
    "/rs/profile/status/former": "Former Staff",
    "/rs/profile/status/external": "External Staff",
    "/rs/profile/bibliometrics": "Bibliometrics",
    "/rs/profile/tab-title/affiliated": " Affiliated",
    "/rs/profile/tab-title/about-researcher": "About Researcher",
    "/rs/profile/tab/publications": "Institution Affiliated Publications",
    "/rs/profile/tab/theses": "Supervised Theses",
    "/rs/profile/tab/projects": "Projects",
    "/rs/profile/tab/courses": "Courses",
    "/rs/profile/tab/affiliations": "Affiliations",
    "/rs/profile/tab/educations": "Educations",
    "/rs/profile/tab/biography": "Biography",
    "/rs/profile/tab/biographyNative": "Biography Native",
    "/rs/profile/tab/competencyCloud": "Competency Cloud",
    "/rs/profile/tab/researchInterests": "Research Interests",
    "/rs/profile/tab/awards": "Awards",
    "/rs/profile/projects/id": "ID",
    "/rs/profile/projects/program": "Program",
    "/rs/profile/projects/grantNo": "Grant No",
    "/rs/profile/projects/duration": "Duration",
    "/rs/profile/projects/startDate": "Start Date",
    "/rs/profile/projects/endDate": "End Date",
    "/rs/profile/projects/fund": "Fund",
    "/rs/profile/print-footer": "Created by GCRIS.",
    "/rs/profile/google-analytics/visitor-traffic":
      "Google Analytics Visitor Traffic",
    "/rs/profile/google-analytics/visitor-traffic-is-loading":
      "Google Analytics Visitor Traffic is loading...",
    "/rs/profile/valid-for-all-publications": "'s all publications.",
    "/rs/profile/all-publications-orcid": "All publications (ORCID)",

    // pubCountByYears
    "/rs/pubCountByYears/title": "Scholarly Output",

    // pubStudyAreaDist
    "/rs/pubStudyAreaDist/title": "Title",

    // pubStudyCategoryDist
    "/rs/pubStudyCategoryDist/title": "Title",

    // charts/handle/sobiad
    "/charts/handle/sobiad/publicationCount": "Publication Count",

    // charts/handle/semantic-scholar
    "/charts/handle/semantic-scholar/citationCount": "Citation Count",

    // charts/handle/open-citations
    "/charts/handle/open-citations/citationCount": "Citation Count",

    // charts/handle/semantic-scholar-recommendations
    "/charts/handle/semantic-scholar/recommendation/year": "Year",
    "/charts/handle/semantic-scholar/recommendation/by": "Authors",
    "/charts/handle/semantic-scholar/recommendation/citationCount":
      "Citation Count",
    "/charts/handle/semantic-scholar/recommendation/semanticScholarRecommendations":
      "Semantic Scholar Recommender",

    // charts/handle/world-map
    "/charts/handle/world-map": "Data analysis date range",
    "/charts/handle/world-map-current": "Current (Refresh every three minute)",
    "/charts/handle/world-map/total-view": "Total View",
  },
};

export const t = (lang, key) => {
  return map[map[lang] ? lang : "tr"][key] ?? "";
};
